module.exports = __webpack_public_path__ + "img/pdf_bg_red_extra.1c008dbf.png";